import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent, SpinnerComponent } from '@mzic/mzic-components';
import { MzicTooltipDirective } from '@mzic/mzic-directives';

export type CollectionReportFileCardAction = 'NONE' | 'REMOVE' | 'RETRY';
export type CollectionReportFileCardStatus =
  | 'DEFAULT'
  | 'UPLOADING'
  | 'UPLOAD_FAILED'
  | 'VALIDATION_RESOLVABLE'
  | 'VALIDATION_PERMANENT';

@Component({
  selector: 'lib-collection-report-file-card',
  imports: [
    CommonModule,
    TranslocoModule,
    MzicSvgComponent,
    MzicTooltipDirective,
    SpinnerComponent,
  ],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './collection-report-file-card.component.html',
  styleUrl: './collection-report-file-card.component.scss',
})
export class CollectionReportFileCardComponent {
  @Input({ required: true }) fileName = '';
  @Input() sizeBytes: number | null = null;
  @Input() action: CollectionReportFileCardAction = 'NONE';
  @Input() status: CollectionReportFileCardStatus = 'DEFAULT';
  @Input() statusLabel = '';
  @Input() statusDetail = '';
  @Input() actionDisabled = false;
  @Output() readonly removeFile = new EventEmitter<void>();
  @Output() readonly retryUpload = new EventEmitter<void>();

  getFileIcon(filename: string): string {
    const extension = filename.slice(filename.lastIndexOf('.')).toLowerCase();
    if (extension === '.pdf') return 'assets/icons/pdf-icon.svg';
    if (extension === '.txt') return 'assets/icons/txt-icon.svg';
    if (extension === '.tab') return 'assets/icons/tab-icon.svg';
    if (extension === '.tsv') return 'assets/icons/tsv-icon.svg';
    if (extension === '.xls' || extension === '.xlsx' || extension === '.csv') {
      return 'assets/icons/excel-icon.svg';
    }
    return 'assets/icons/mzic-document.svg';
  }

  formatFileSize(bytes: number | null): string {
    if (bytes === null) return '';
    if (bytes === 0) return '0 Bytes';
    const unit = Math.floor(Math.log(bytes) / Math.log(1024));
    const units = ['Bytes', 'KB', 'MB', 'GB'];
    return `${Math.round((bytes / 1024 ** unit) * 100) / 100} ${units[unit]}`;
  }
}
